<template>
  <span class="wrapper">
    <span class="web__msg--audio" v-if="text.type==='text'" v-html="parseText(text.content)"/>
      <Icon type="ios-volume-up" @click="playAudio(`text-audio`+text.extract)" v-if="text.extract" class="web__msg--icon"></Icon>
      <audio :id="`text-audio`+text.extract" class="we__msg--audio hidden_audio" v-if="text.extract" hidden :src="text.fileFull?this.baseImgURL+text.extract_relative:this.baseImgURL+text.extract"/>
      <img class="web__msg--img" v-if="text.type === 'img'" :src="text.fileFull?text.content:this.baseImgURL+text.content" alt @click="showDialog({tag:text.type,src:text.content})" />
      <video class="web__msg--video" v-if="text.type === 'video'" :src="text.fileFull?text.content:this.baseImgURL+text.content" controls="controls" controlsList="nodownload"  @click="showDialog({tag:text.type,src:text.content})"/>
      <audio class="web__msg--audio" v-if="text.type === 'audio'" style="width: 350px;height: 20px;" :src="text.fileFull?text.content:this.baseImgURL+text.content" controls="controls" controlsList="nodownload"/>
    <el-dialog :visible.sync="show" width="40%" append-to-body :before-close="handleClose" class="web__dialog">
      <img :src="imgSrc" v-if="imgSrc" style="width: 100%;object-fit: cover"/>
      <video :src="videoSrc" v-if="videoSrc" style="width: 100%;object-fit: cover" controls="controls"></video>
      <audio :src="audioSrc" v-if="audioSrc" style="width: 100%;object-fit: cover" controls="controls"></audio>
    </el-dialog>
  </span>
</template>

<script>
  export default {
    name: "itemTalk",
    props:['text'],
    data(){
      return {
        tags:['img','video','audio'],
        show:false,
        imgSrc:'',
        videoSrc:'',
        audioSrc:'',
      }
    },
    computed:{
      getText() {
        const str = this.text || ''
        let strArr = str.split("<html>");
        let arr = []
        for (let i = 0; i < strArr.length; i++) {
          let json = {}
          json.text = strArr[i]
          arr.push(json)
        }
        return arr
      },
      /*getTag() {
        const str = this.text || ''
        let tag = 'span'
        let type = ''
        const isTag = str.match(/(?!^<)[A-Z|a-z]+/)
        isTag && (type=isTag[0])
        if (this.tags.includes(type)) {
          tag = type
        }
        return tag
      },
      getData() {
        const str = this.text || ''
        const dom = document.createElement('div')
        dom.innerHTML = str
        const target = dom.firstChild

        const src = target.getAttribute('data-src')
        const controls = target.getAttribute('controls') || false
        return {
          src,
          controls
        }
      }*/
    },
    methods:{
      handleClose(done) {
        this.imgSrc = undefined
        this.videoSrc = undefined
        this.audioSrc = undefined
        done()
      },
      playAudio(id) {
        let audio = document.getElementById(id)
        let audios = document.getElementsByClassName('hidden_audio')
        if (audio.readyState) {
          if (audio.paused || audio.ended) {
            for (let i = 0; i < audios.length; i++) {
              audios[i].pause()
            }
            audio.load()
            audio.play();
          } else {
            audio.pause()
          }
        }
      },
      beforeOpen(config, callback) {
        callback()
      },
      showDialog({tag,src}) {
        const callback = () => {
          if (tag === 'img') {
            this.imgSrc = src
            this.show = true
          }else if (tag === 'video') {
            this.videoSrc = src
            this.show = true
          }else if (tag === 'FILE') {
            window.open(src)
          }
        }
        if (typeof this.beforeOpen === 'function') {
          this.beforeOpen({tag, src}, callback);
        } else {
          callback()
        }
      },
      parseText(text) {
        if (!text) return
        //没有表情
        // const html = emojiParser(text).replace(/<img src/g,'<img data-class="iconBox" src').replace(/\n/g,'<br/>')
        return text
      }
    }
  }
</script>

<style scoped lang="css">
.wrapper {
  padding: 0px;
  margin: 0px;
}
  .web__msg--icon{
    font-size: 19px;
    cursor: pointer;
  }
</style>



// WEBPACK FOOTER //
// src/components/aiManager/chat/itemTalk.vue